import React from 'react';
import { useIntl } from 'umi';
import MultipleChoice from '@/pages/intelligence/components/MultipleChoice';
import { Button, Modal } from 'tea-component';

export default function CheckboxContent(props: any) {
  const { selected = [], context, uniqueKey, onChange = () => console.log, isLabelHide, color, maxCheckNum = 10 } = props;
  const { formatMessage } = useIntl();
  const current = selected?.find((t: any) => context?.[uniqueKey] === t?.[uniqueKey]);
  return (
    <MultipleChoice
      value={context?.[uniqueKey] === current?.[uniqueKey]}
      isLabelHide={isLabelHide}
      color={color}
      onChange={(v: boolean) => {
        if (v) {
          if (selected.length >= maxCheckNum) {
            Modal.error({
              size: 'm',
              message: formatMessage({ id: 'dbi_top_charts_table_selection_limit_title' }),
              description: formatMessage({ id: 'dbi_top_charts_table_selection_limit_tips' }, { num: maxCheckNum }),
              buttons: [<Button type="primary">{formatMessage({ id: 'dbi_confirm' })}</Button>],
            });
            return;
          }
          onChange(context, 'check');
        } else {
          onChange(current, 'uncheck');
        }
      }}
    />
  );
}
